import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UsersService } from 'src/app/features/users/users.service';
import { Constants } from '../constants/constants';

/**
 * Interface for data that is resolved for the (activate user | update password) page
 */
export interface UpdatePasswordResolvedParams {
    title: string;
    bodyTitle: string;
    successTitle: string;
    saveButtonText: string;
    submitAction: (data: any) => Observable<any>;
    redirectionPath: string;
    language: string;
    showPrivacyPolicyLink: boolean;
    company: string | null;
    token: string;
}

export const UpdatePasswordResolver: ResolveFn<UpdatePasswordResolvedParams | RedirectCommand> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    // Section: SERVICES / DEPENDENCIES
    //----------------------------------------------------------------------
    const router = inject(Router);
    const usersService = inject(UsersService);

    // Section: LOGIC
    //----------------------------------------------------------------------
    const token: string | null = route.queryParamMap.get('token');
    const company: string | null = route.queryParamMap.get('c');
    const lang: string | null = route.queryParamMap.get('lang');
    const path = route.routeConfig?.path;

    if (!token) {
        return new RedirectCommand(router.parseUrl('/forbidden'));
    }

    const baseResolvedData = {
        language: lang || Constants.defaultLanguage,
        company: company,
        token: token
    };

    if (path === 'activate-user') {
        return {
            ...baseResolvedData,
            title: 'login.form.activateuser',
            bodyTitle: 'login.form.activateAccount',
            successTitle: 'updatePassword.userActivated',
            saveButtonText: 'users.activate',
            submitAction: (data: any) => usersService.activateNewUser(data),
            redirectionPath: '/activated-account',
            showPrivacyPolicyLink: true
        };
    } else {
        return {
            ...baseResolvedData,
            title: 'login.form.updatepassword',
            bodyTitle: 'login.form.updatepassword',
            successTitle: 'login.form.passwordupdated',
            saveButtonText: 'global.form.save',
            submitAction: (data: any) => usersService.resetPassword(data),
            redirectionPath: '/password-updated',
            showPrivacyPolicyLink: false
        };
    }
};
